<template>
  <b-modal
    ref="modalCadastro"
    footer-class="estilo-rodape-empresa"
    id="ModalEmpresaCadastro"
    size="lg"
    :no-close-on-backdrop="loadingSalvar || carregandoCnae"
    :no-close-on-esc="loadingSalvar || carregandoCnae"
  >
    <!-- <div slot="modal-header" class="title-area modal-delete">
      <div class="modal-title modal-title-empresa">{} </div>

      <i class="modal-close-icon" @click="">
        <font-awesome-icon icon="times" />
      </i>
    </div> -->
    <Header :titulo="`${titleModal} Empresa`" :close="closeModal" slot="modal-header" />
    <div class="modal-empresa-corpo">
      <ModalEmpresaPrimeiraLinha
        :calculaForm="calculaForm"
        :form="form"
        :exibeValidacao="exibeValidacao"
        :camposRequeridos="camposRequeridos"
        :handleCnpj="handleCnpj"
      />
      <ModalEmpresaTerceiraLinha
        :calculaForm="calculaForm"
        :form="form"
        :exibeValidacao="exibeValidacao"
        :camposRequeridos="camposRequeridos"
      />
      <ModalEmpresaSegundaLinha
        v-if="!carregandoCnae"
        :limpaModalEmpresa="limpaModalEmpresa"
        :calculaForm="calculaForm"
        :form="form"
        :listaCnae="listaCnae"
        :inserirCnae="inserirCnae"
        :removerCnae="removerCnae"
        :exibeValidacao="exibeValidacao"
        :camposRequeridos="camposRequeridos"
      />
    </div>
    <LoadingPadraoContainer
      v-if="loadingSalvar || carregandoCnae"
      class="loading-padrao-backdrop"
      background
      :fraseLoading="['Cadastrando Empresa', 'Aguarde um momento']"
      delay="5000"
      classe="azul"
    />
    <LoadingPadraoContainer
      v-if="carregandoCnae"
      class="loading-padrao-backdrop"
      background
      :fraseLoading="['Carregansdo lista de CNAEs', 'Aguarde um momento']"
      delay="5000"
      classe="azul"
    />

    <div slot="modal-footer">
      <div class="container-modal-footer-empresa">
        <div class="info">
          <font-awesome-icon icon="info-circle" class="icon mr-2" />
          <span>Excluir ou incluir informações é de responsabilidade do usuário</span>
        </div>
        <div class="botão-modal-empresa">
          <BotaoPadrao
            arredondadoEsquerda
            class="botao-padding"
            nome="Cancelar"
            icone="times"
            :click="closeModal"
            :desabilita="loadingSalvar || carregandoCnae"
          />
          <BotaoPadrao
            v-if="blUsuarioPro"
            arredondadoEsquerda
            class="botao-padding"
            nome="Salvar"
            icone="check"
            :click="onClickSalvar"
            cor="azul"
            desabilita
            tooltip="Opção desabilitada na versão de testes"
          />
          <BotaoPadrao
            v-else
            arredondadoEsquerda
            class="botao-padding"
            nome="Salvar"
            icone="check"
            :click="onClickSalvar"
            cor="azul"
            :desabilita="loadingSalvar || carregandoCnae"
          />
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ModalEmpresaPrimeiraLinha from "./ModalEmpresaPrimeiraLinha.vue";
import ModalEmpresaSegundaLinha from "./ModalEmpresaSegundaLinha.vue";
import ModalEmpresaTerceiraLinha from "./ModalEmpresaTerceiraLinha.vue";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import CenarioInput from "../CenarioInput/CenarioInput.vue";
import filtros from "@/store/modules/cenarioFiltros.js";
import Header from "@/components/ModalComponente/Header.vue";

import Api from "@/services/api.js";
import { mapGetters } from "vuex";
// import CnpjCaptcha from "../CnpjCaptcha/CnpjCaptcha.vue";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

export default {
  name: "ModalEmpresa",
  components: {
    BotaoPadrao,
    CenarioInput,
    ModalEmpresaPrimeiraLinha,
    ModalEmpresaSegundaLinha,
    ModalEmpresaTerceiraLinha,
    // CnpjCaptcha,
    Header,
    LoadingPadraoContainer
  },
  inject: ["pushAlert"],
  props: {
    titleModal: String,
    formEmpresaModal: Object,
    formEmpresaModalEditar: Object,
    limpaModalEmpresa: Boolean,
    verificaCNPJ: Function
  },
  data() {
    return {
      filtros,
      exibeValidacao: false,
      loadingSalvar: false,
      carregandoCnae: false,
      listaCnae: [],
      form: {
        id: "",
        cnpj: "",
        nome: "",
        cnae: [],
        uf: "",
        regime: ""
      }
    };
  },
  created() {
    this.obtemCnae();
  },
  watch: {
    formEmpresaModal: {
      deep: true,
      handler() {
        this.form.nome = this.formEmpresaModal.nome;
        this.form.uf = this.filtros.estado_origem.valores.find(
          f => f.sigla == this.formEmpresaModal.uf
        ).value;
        let cnae = [];
        this.formEmpresaModal.cnae.forEach(e => {
          let foundCnae = this.listaCnae.find(f => f.value == e.id_cnae);
          if (foundCnae) {
            cnae.push({ label: foundCnae.label, value: foundCnae.value });
          }
        });
        this.form.cnae = cnae;
      }
    },
    formEmpresaModalEditar: {
      deep: true,
      handler() {
        this.form.id = this.formEmpresaModalEditar.id;
        this.form.cnpj = this.formEmpresaModalEditar.cnpj;
        this.form.nome = this.formEmpresaModalEditar.nome;
        this.form.uf = this.formEmpresaModalEditar.uf;
        this.form.regime = this.formEmpresaModalEditar.regime;
        let cnae = [];
        this.formEmpresaModalEditar.cnae.forEach(e => {
          let foundCnae = this.listaCnae.find(f => f.value == e.id_cnae);
          if (foundCnae) {
            cnae.push({ label: foundCnae.label, value: foundCnae.value });
          }
        });
        this.form.cnae = cnae;
      }
    },
    carregandoCnae() {
      if (this.titleModal == "Editar") {
        let cnae = [];
        this.formEmpresaModalEditar.cnae.forEach(e => {
          let foundCnae = this.listaCnae.find(f => f.value == e.id_cnae);
          if (foundCnae) {
            cnae.push({ label: foundCnae.label, value: foundCnae.value });
          }
        });
        this.form.cnae = cnae;
      }
    },
    limpaModalEmpresa() {
      this.exibeValidacao = false;
      if (this.titleModal != "Editar") {
        this.form = {
          id: "",
          cnpj: "",
          nome: "",
          cnae: [],
          uf: "",
          regime: ""
        };
      }
    }
  },
  computed: {
    ...mapGetters("login", ["getUser"]),
    ...mapGetters("empresa", ["getListEmpresa"]),
    ...mapGetters("auth", {
      blUsuarioPro: "getUsuarioPro"
    }),
    // blUsuarioPro() {
    //   return true;
    // },

    camposRequeridos() {
      let requerido = {
        cnpj: this.form.cnpj.length != 18 ? true : false,
        nome: this.form.nome == "" ? true : false,
        cnae: this.form.cnae.length == 0 ? true : false,
        uf: this.form.uf == "" ? true : false,
        regime: this.form.regime == "" ? true : false
      };
      let requeridoFiltrado = Object.fromEntries(
        Object.entries(requerido).filter(([_, value]) => value == true)
      );
      return requeridoFiltrado;
    },
    permiteResultado() {
      let bool = !Object.keys(this.camposRequeridos).length;
      if (bool) {
        this.exibeValidacao = false;
      }
      return bool;
    }
  },
  methods: {
    handleCnpj() {
      this.verificaCNPJ(this.form);
    },
    async onClickSalvar() {
      if (!this.permiteResultado) {
        this.exibeValidacao = true;
        this.pushAlert("É necessário preencher todos os campos do formulário.", "danger");
        return;
      }
      this.loadingSalvar = true;
      try {
        if (
          this.getListEmpresa.filter(f => f.cnpj == this.form.cnpj).length > 0 &&
          this.form.id == ""
        ) {
          this.pushAlert("Empresa já cadastrada.", "danger");
          this.loadingSalvar = false;
          return;
        }

        let dados = {
          id: this.form.id,
          nome: this.form.nome,
          cnpj: this.form.cnpj,
          id_cnpj: 0,
          arCnae: this.form.cnae,
          id_regime_tributario: this.form.regime,
          id_uf: this.form.uf,
          id_usuario: this.getUser.id_usuario
        };
        if (this.titleModal == "Editar") {
          await new Api().post(`Empresa/alterarEmpresa/${this.form.id}`, dados);
        } else {
          await new Api().post("Empresa/inserirEmpresa", dados);
        }
        this.pushAlert("Empresa Cadastrada com sucesso!", "success");
        this.loadingSalvar = false;
      } catch (error) {
        console.error(error);
        this.pushAlert("Erro ao cadastrar Empresa!", "danger");
        this.loadingSalvar = false;
      }
      this.$emit("atualizaEmpresas");
      this.$root.$emit("bv::hide::modal", `ModalEmpresaCadastro`);
    },
    closeModal() {
      this.$root.$emit("bv::hide::modal", `ModalEmpresaCadastro`);
    },
    calculaForm(dado, campo) {
      this.form[campo] = dado;
    },
    inserirCnae(cnae) {
      this.form.cnae.push(cnae);
    },
    removerCnae(cnae) {
      let index = this.form.cnae.indexOf(this.form.cnae.find(f => f.value == cnae.value));
      this.form.cnae.splice(index, 1);
    },
    async obtemCnae() {
      this.carregandoCnae = true;
      let payload = {
        ncm: null,
        actionR: null,
        actionD: null,
        empresaR: null,
        empresaD: null,
        ncm_cliente: []
      };
      try {
        let response = await new Api().post("Cnpj/getCnaesRemetente", payload);
        this.listaCnae = response.dados.des;
      } catch (error) {
        console.error(error);
      }
      this.carregandoCnae = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.container-modal-footer-empresa {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.estilo-rodape-empresa > div {
  width: 100%;
}
.modal-empresa-corpo {
  position: relative;
}
</style>
